import { useCallback, useState } from 'react'
import { SESSION_DATA_IDENTIFIER } from './sessionToken.utils'

type SessionData = {
  token?: string
}

/**
 * Hook for managing session data in localStorage.
 *
 * Reads and writes session data synchronously from localStorage.
 */
export const useSessionData = () => {
  const [data, setDataState] = useState<SessionData | undefined>(() => {
    const stored = localStorage.getItem(SESSION_DATA_IDENTIFIER)
    if (stored) {
      try {
        return JSON.parse(stored) as SessionData
      } catch {
        return undefined
      }
    }
    return undefined
  })

  const setData = useCallback((value: SessionData | undefined) => {
    if (value !== undefined && value !== null) {
      localStorage.setItem(SESSION_DATA_IDENTIFIER, JSON.stringify(value))
      setDataState(value)
    } else {
      localStorage.removeItem(SESSION_DATA_IDENTIFIER)
      setDataState(undefined)
    }
  }, [])

  return { data, setData }
}
